import { useMemo } from 'react';
import { useApiQuery } from './useApiQuery';
import { partnersApi } from '@/api/partners';
import type { Partner, PartnerFilters, PartnerListResponse } from '@/api/partners';
import mockData from '@/data/mock-data.json';

interface UsePartnersOptions {
  filters?: PartnerFilters;
  enabled?: boolean;
}

export const usePartners = (options: UsePartnersOptions = {}) => {
  const { filters = {}, enabled = true } = options;

  const mockPartners = useMemo<PartnerListResponse>(() => ({
    partners: mockData.partners as Partner[],
    total: mockData.partners.length,
  }), []);

  const { data, isLoading, error, isUsingMockData, reload } = useApiQuery<PartnerListResponse>(
    {
      queryFn: () => partnersApi.list(filters),
      mockData: mockPartners,
      enabled,
    },
    [filters.search, filters.status, filters.page, filters.limit],
  );

  return {
    partners: data?.partners ?? [],
    total: data?.total ?? 0,
    isLoading,
    error,
    isUsingMockData,
    reload,
  };
};
